import { CAMPAIGN_UPDATES_FETCH } from '../actions/types'

export default function(state = {}, action) {
  switch (action.type) {
    case CAMPAIGN_UPDATES_FETCH:
      return { ...action.payload }

    default:
      return state
  }
}
